import { REGEX } from "../constants/globalConstant";
export const validatePasswordPolicy = ({password, passwordPolicy}) => {
    const errors = [];
    
    // Check for minimum password length
    if (passwordPolicy?.isMinimumPasswordLengthEnforced && password?.length < passwordPolicy?.minimumPasswordLength) {
      errors.push(`${passwordPolicy?.minimumPasswordLength} characters`);
    }
  
    // Check for digit requirement
    if (passwordPolicy?.isDigitRequired && !REGEX.DIGITS.test(password)) {
      errors.push("one digit");
    }
  
    // Check for letter requirement
    if (passwordPolicy?.isLetterRequired && !REGEX.ALPHABETS.test(password)) {
      errors.push("one letter");
    }
  
    // Check for uppercase letter requirement
    if (passwordPolicy?.isUpperCaseLetterRequired && !REGEX.UPPERCASE_ALPHABETS.test(password)) {
      errors.push("one uppercase letter");
    }
  
    // Check for lowercase letter requirement
    if (passwordPolicy?.isLowerCaseLetterRequired && !REGEX.LOWERCASE_ALPHABETS.test(password)) {
      errors.push("one lowercase letter");
    }
  
    // Check for special character requirement
    if (passwordPolicy?.isSpecialCharacterRequired && !REGEX.SPECIAL_CHARACTERS.test(password)) {
      errors.push("one special character");
    }
  
    // Join errors with proper formatting
    if (errors.length) {
      const lastError = errors.pop(); // Get the last error
      const errorString = errors.length
        ? `Password must have atleast ${errors.join(", ")} and ${lastError}` // Join with commas and "and" for the last item
        : `Password must have ${lastError}`; // Single error case
      return errorString;
    }
  
    return null; // No errors
  };
  